import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { DeliveryOption, PrintFinish } from '../../prop-types';
import AddToCartControls from '../../common/add-to-cart-controls';
import {
  availableDeliveryOptionsForFinish,
  availableFinishKeys,
  availableFinishOptions,
  calculateSelectedFinish,
  selectedDeliveryOption,
  addSelectedAttributeToOptions,
} from '../../common/finish-and-delivery-options';
import ButtonOptions from './button-options';
import DropdownOptions from './dropdown-options';
import Button from '../../../_common/button';

export const SummaryDropdownContext = createContext({
  finishSelectorOptions: [],
  deliverySelectorOptions: [],
  selectedFinishOption: null,
  selectedDeliveryOption: null,
});

const OPTIONS_LIMIT = 2;

export default function SummaryDropdown({
  deliveryOption,
  deliveryOptions,
  finishesByDeliveryOption,
  finishes,
  finish,
  basketUrl,
  allowMultiplePrintFinishesPerOrder,
  addToCartEnabled,
  handleOptionsChanged,
  handleAddToCart,
}) {
  const displayOptionsAsDropdowns =
    deliveryOptions.length > OPTIONS_LIMIT || finishes.length > OPTIONS_LIMIT;

  const finishKeys = availableFinishKeys(
    finishesByDeliveryOption,
    deliveryOption
  );

  const handleFinishChange = value => {
    const selectedFinish = calculateSelectedFinish(
      deliveryOption.key,
      value,
      finishesByDeliveryOption
    );

    if (selectedFinish.key == finish.key) {
      return;
    }

    if (allowMultiplePrintFinishesPerOrder) {
      window.location = `${window.location.pathname}?finish=${selectedFinish.title}`;
    } else {
      handleOptionsChanged({ finish: selectedFinish });
    }
  };

  const handleDeliveryChange = value => {
    handleOptionsChanged({
      delivery_option: selectedDeliveryOption(deliveryOptions, value),
    });
  };

  return (
    <SummaryDropdownContext.Provider
      value={{
        allowMultiplePrintFinishesPerOrder,
        finishSelectorOptions: addSelectedAttributeToOptions(
          availableFinishOptions(finishes, finishKeys),
          finish.key
        ),
        selectedFinishOption: finish,
        selectedDeliveryOption: deliveryOption,
        deliverySelectorOptions: addSelectedAttributeToOptions(
          availableDeliveryOptionsForFinish(
            deliveryOptions,
            finishesByDeliveryOption,
            finish,
            true
          ),
          deliveryOption.key
        ),
      }}>
      <div className="grey-zone print-order__summary-dropdown">
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <Button
              className="btn-link p-0 border-0 collapsed print-order__title"
              type="button"
              data-toggle="collapse"
              data-target="#summary-chart"
              aria-expanded="true"
              aria-controls="summary-chart"
              aria-label="Order Options"
              text="Order Options"
            />
          </div>
          <div>
            <AddToCartControls
              enabled={addToCartEnabled}
              basketUrl={basketUrl}
              onAddToCart={handleAddToCart}
            />
          </div>
        </div>

        <div id="summary-chart" className="collapse show">
          <div className="print-order__summary">
            {(displayOptionsAsDropdowns && (
              <DropdownOptions
                handleFinishChange={handleFinishChange}
                handleDeliveryChange={handleDeliveryChange}
              />
            )) || (
              <ButtonOptions
                handleFinishChange={handleFinishChange}
                handleDeliveryChange={handleDeliveryChange}
              />
            )}
          </div>
        </div>
      </div>
    </SummaryDropdownContext.Provider>
  );
}

SummaryDropdown.propTypes = {
  deliveryOption: DeliveryOption.isRequired,
  deliveryOptions: PropTypes.arrayOf(DeliveryOption).isRequired,
  finishesByDeliveryOption: PropTypes.objectOf(PropTypes.arrayOf(PrintFinish))
    .isRequired,
  finishes: PropTypes.arrayOf(PrintFinish).isRequired,
  finish: PrintFinish.isRequired,
  basketUrl: PropTypes.string.isRequired,
  allowMultiplePrintFinishesPerOrder: PropTypes.bool,
  addToCartEnabled: PropTypes.bool.isRequired,
  handleOptionsChanged: PropTypes.func.isRequired,
  handleAddToCart: PropTypes.func.isRequired,
};

SummaryDropdown.defaultProps = {
  allowMultiplePrintFinishesPerOrder: false,
};
